import type { AppThunk } from '@core/core/store'
import { selectCompanyById } from '@core/core/store'
import type { CompanyId } from '@core/core/types'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { getAllCompaniesApi, getFieldIdsForCompanyApi } from '../../api'
import { companiesSlice } from './companiesSlice'

const { addCompanies } = companiesSlice.actions

export const getCompanies = (): AppThunk => dispatch => {
  getAllCompaniesApi()
    .then(companies => dispatch(addCompanies(companies)))
    .catch(console.error)
}

export const loadCompanyFieldIds = createAsyncThunk(
  'companies/LoadFCompanyFieldIds',
  async (companyId: CompanyId) => {
    const fieldIds = await getFieldIdsForCompanyApi(companyId)
    return { companyId, fieldIds }
  },
)

export const loadNotExistingCompanyFieldIds = (companyId: CompanyId): AppThunk => {
  return (dispatch, getState) => {
    const existing = selectCompanyById(getState(), companyId)
    if (existing && existing.fieldIds === undefined) {
      dispatch(loadCompanyFieldIds(companyId))
    }
  }
}
